function About() {
    return (
        <div>
            <h2>Contact Us</h2>
            <p className='no-newline-after-p'>Please direct any submission related inquiries to:</p>
            <p className='no-newline-after-p'>Professor Dr Arun Patil, Curtin University Singapore</p>
            <p className='no-newline-after-p'>Email: <a href="mailto:arun.patil@curtin.edu.sg" target='_blank' rel="noreferrer noopener">arun.patil@curtin.edu.sg</a></p>
            <p className='no-newline-after-p'>OR</p>
            <p className='no-newline-after-p'>Assoc. Prof. Dr. Nguyen Minh Ly, The University of Da Nang - University of Science and Education</p>
            <p>Email: <a href="mailto:Minhlyvn24@gmail.com" target='_blank' rel="noreferrer noopener">Minhlyvn24@gmail.com</a>, <a href="mailto:nmly@ued.udn.vn" target='_blank' rel="noreferrer noopener">nmly@ued.udn.vn</a></p>
            <p>For any other queries: <a href="mailto:contact@ietbhec.com" target='_blank' rel="noreferrer noopener">contact@ietbhec.com</a></p>
        </div>
    )
}

export default About